import {createFileRoute} from '@tanstack/react-router'

import ChannelsScreen from '@protected/channels'

export const Route = createFileRoute('/_protected/channels')({component: ChannelsScreen})
